import React, { useState } from "react";
import OtpInput from "react-otp-input";
import Countdown from "react-countdown";

const OtpWithTimer = ({ onOtpChange, otp, setOtp }) => {
  const [resendActive, setResendActive] = useState(false);
  const [key, setKey] = useState(0);

  const handleOtpChange = (value) => {
    if (/^\d*$/.test(value)) {
      setOtp(value);
      
      if (onOtpChange) {
        onOtpChange(value);
      }
      
      if (value.length === 4) {
        // console.log("Complete OTP entered:", value);
      }
    }
  };

  const handleResend = () => {
    // Trigger resend logic here
    setOtp("");
    setResendActive(false);
    setKey((prev) => prev + 1); // restart countdown
  };

  const renderer = ({ minutes, seconds, completed }) => {
    if (completed) {
      setResendActive(true);
      return (
        <span className="text-red-500">OTP expired. Resend available.</span>
      );
    } else {
      return (
        <span className="text-gray-600">
          Resend OTP in {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
        </span>
      );
    }
  };

  return (
    <div className="md:py-4 w-full -ml-2">
      <style>{`
        @media (max-width: 640px) {
          .otp-input-custom { width: 2.5rem !important; }
        }
        @media (min-width: 641px) {
          .otp-input-custom { width: 3rem !important; }
        }
      `}</style>
      <OtpInput
        value={otp}
        onChange={handleOtpChange}
        numInputs={4}
        renderInput={(props, index) => (
          <div style={{ display: "flex", alignItems: "center" }} key={index}>
            <input
              {...props}
              inputMode="numeric"
              pattern="[0-9]*"
              className="otp-input-custom"
              style={{
                height: "3rem",
                padding: "0.5rem",
                fontSize: "1.2rem",
                margin: "0 0.3rem",
                borderRadius: "4px",
                border: "1px solid #ccc",
                textAlign: "center",
                boxSizing: "border-box",
              }}
            />
            {index < 3 && (
              <span style={{ margin: "0 0.3rem", fontSize: "1.2rem" }}>-</span>
            )}
          </div>
        )}
      />

      {/* <div className="mt-4">
        <Countdown
          key={key}
          date={Date.now() + 1000 * 5} // 60 seconds countdown
          renderer={renderer}
        />
      </div> */}
    </div>
  );
};

export default OtpWithTimer;
